export interface RuntimeConfig {
  readonly stage: 'sandbox' | 'production';
  readonly apiBaseUrl: string;
  readonly cognitoUserPoolId: string;
  readonly cognitoClientId: string;
  readonly region: string;
}

declare global {
  interface Window {
    __CRIME_RUNTIME_CONFIG__?: Partial<RuntimeConfig>;
  }
}

function readStage(stage?: string): RuntimeConfig['stage'] {
  return stage === 'production' ? 'production' : 'sandbox';
}

export function getRuntimeConfig(): RuntimeConfig {
  const runtime = window.__CRIME_RUNTIME_CONFIG__ ?? {};

  return {
    stage: readStage(runtime.stage ?? process.env.REACT_APP_STAGE),
    apiBaseUrl: runtime.apiBaseUrl ?? process.env.REACT_APP_API_BASE_URL ?? '',
    cognitoUserPoolId: runtime.cognitoUserPoolId ?? process.env.REACT_APP_COGNITO_USER_POOL_ID ?? '',
    cognitoClientId: runtime.cognitoClientId ?? process.env.REACT_APP_COGNITO_CLIENT_ID ?? '',
    region: runtime.region ?? process.env.REACT_APP_AWS_REGION ?? 'eu-north-1',
  };
}
